import React, { useState } from 'react';

import OrganizationStrategy from './OrganizationStrategy';
import MissionOrganization from './MissionOrganization';
import VisionOrganization from './VisionOrganization';
import SupportInfo from './SupportInfo';
import ContactUs from './ContactUs';
import AboutUs from './AboutUs';
import Rules from './Rules';
import UploadLogo from './UploadLogo';
import SupportPhone from './SupportPhone';
import PaymentType from './PaymentType';
import Transfer from './Transfer';




const Info = () => {

    const [currentTab, setCurrentTab] = useState('aboutUs');

    return (
        <div className="card">
            <div className="card-header"><div className="card-title">اطلاعات پایه</div></div>
            <div className="card-body">
                <div className="row mb-5">
                    <div className="col-md-1 d-grid p-1">
                        <button onClick={e => setCurrentTab('aboutUs')} className={currentTab == 'aboutUs' ? 'btn btn-info' : 'btn btn-info-light'}>درباره ما</button>
                    </div>
                    <div className="col-md-1 d-grid  p-1">
                        <button onClick={e => setCurrentTab('visionOrganization')} className={currentTab == 'visionOrganization' ? 'btn btn-info' : 'btn btn-info-light'}>      چشم انداز سازمان  </button>
                    </div>
                    <div className="col-md-1 d-grid p-1">
                        <button onClick={e => setCurrentTab('organizationStrategy')} className={currentTab == 'organizationStrategy' ? 'btn btn-info' : 'btn btn-info-light'}>استراتژی سازمان</button>
                    </div>
                    <div className="col-md-1 d-grid p-1">
                        <button onClick={e => setCurrentTab('missionOrganization')} className={currentTab == 'missionOrganization' ? 'btn btn-info' : 'btn btn-info-light'}>    ماموریت سازمان    </button>
                    </div>
                    <div className="col-md-1 d-grid p-1">
                        <button onClick={e => setCurrentTab('supportInfo')} className={currentTab == 'supportInfo' ? 'btn btn-info' : 'btn btn-info-light'}>اطلاعات پشتیبانی</button>
                    </div>
                    <div className="col-md-1 d-grid p-1">
                        <button onClick={e => setCurrentTab('supportPhone')} className={currentTab == 'supportPhone' ? 'btn btn-info' : 'btn btn-info-light'}>   شماره پشتیبانی </button>
                    </div>
                    <div className="col-md-1 d-grid p-1">
                        <button onClick={e => setCurrentTab('rules')} className={currentTab == 'rules' ? 'btn btn-info' : 'btn btn-info-light'}>  قوانین و مقررات </button>
                    </div>
                    <div className="col-md-1 d-grid p-1">
                        <button onClick={e => setCurrentTab('uploadLogo')} className={currentTab == 'uploadLogo' ? 'btn btn-info' : 'btn btn-info-light'}>     آپلود لوگو   </button>
                    </div>
                    <div className="col-md-1 d-grid p-1">
                        <button onClick={e => setCurrentTab('paymentType')} className={currentTab == 'paymentType' ? 'btn btn-info' : 'btn btn-info-light'}>        پرداخت   </button>
                    </div>
                    <div className="col-md-1 d-grid p-1">
                        <button onClick={e => setCurrentTab('contactUs')} className={currentTab == 'contactUs' ? 'btn btn-info' : 'btn btn-info-light'}>      تماس با ما     </button>
                    </div>
                    <div className="col-md-1 d-grid p-1">
                        <button onClick={e => setCurrentTab('transfer')} className={currentTab == 'transfer' ? 'btn btn-info' : 'btn btn-info-light'}>انتقال اعتبار</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card mb-0">
                            <div className="card-body report-card" style={{ background: '#f0f0f0', borderRadius: 7 }}>
                                {currentTab == 'aboutUs' ? <AboutUs /> : ''}
                                {currentTab == 'organizationStrategy' ? <OrganizationStrategy /> : ''}
                                {currentTab == 'missionOrganization' ? <MissionOrganization /> : ''}
                                {currentTab == 'visionOrganization' ? <VisionOrganization /> : ''}
                                {currentTab == 'contactUs' ? <ContactUs /> : ''}
                                {currentTab == 'supportInfo' ? <SupportInfo /> : ''}
                                {currentTab == 'rules' ? <Rules /> : ''}
                                {currentTab == 'uploadLogo' ? <UploadLogo /> : ''}
                                {currentTab == 'supportPhone' ? <SupportPhone /> : ''}
                                {currentTab == 'paymentType' ? <PaymentType /> : ''}
                                {currentTab == 'transfer' ? <Transfer /> : ''}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Info;